import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { motion } from 'framer-motion';
import { useCreateWorldMarkerV2 } from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { useUploadFile } from 'libs/hooks/io/useUploadFile';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { EWorldAction } from 'libs/utils/world/worldTypes';
import { getCoordinateBounds } from 'libs/utils/world/worldUtils';
import { useContext, useEffect, useRef, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const UploadToolSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const uploadRef = useRef<HTMLLabelElement>();
    const [selectorFiles, setSelectorFiles] = useState<File[]>();
    const { uploaded } = useUploadFile(selectorFiles, 'gpx');
    const [uploadingFile, setUploadingFile] = useState<boolean>(false);
    const createWorldMarker = useCreateWorldMarkerV2();

    useEffect(() => {
        if (uploaded) {
            ctxEdit.setWorldAction(EWorldAction.SELECT);
            console.log('Uploaded', uploaded);
            createWorldMarker.createRoute(uploaded).then((marker) => {
                const bounds = getCoordinateBounds(marker.elementData?.coordinates);

                ctxEdit.mapRef.current?.fitBounds(bounds, {
                    padding: 150,
                    speed: 2,
                    animate: true
                });
            });
            setUploadingFile(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploaded]);

    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_UploadToolSidebar className={props.className}>
                <SidebarSubsection title={Localization.FILE_UPLOAD} icon={{ iconName: 'upload' }}>
                    <SidebarContent>
                        <label className="upload" ref={uploadRef}>
                            <input
                                id="fileUpload"
                                type="file"
                                style={{ display: 'none' }}
                                accept=".gpx"
                                onChange={(e) => {
                                    setUploadingFile(true);
                                    setSelectorFiles(Array.from(e.target['files']));
                                }}
                            />
                            <ActionButton
                                text={
                                    uploadingFile
                                        ? Localization.UPLOADING
                                        : Localization.UPLOAD_ACTION
                                }
                                onClick={() => {
                                    console.log('Upload');
                                }}
                                disabled={uploadingFile}
                            />
                        </label>
                    </SidebarContent>
                </SidebarSubsection>
            </S_UploadToolSidebar>
        </motion.div>
    );
};

const S_UploadToolSidebar = styled.div`
    width: 100%;
`;
